import classNames from 'classnames/bind';
import { PageTransition } from '~/components/common';
import styles from './Header.module.scss';
import Header from './header/Header';
import { Outlet } from 'react-router-dom';

const cx = classNames.bind(styles);

const Main = () => {
  return (
    <div>
      <Header />
      <div className={cx('container')}>
        <div className={cx('content')}>
          <PageTransition>
            <Outlet />
          </PageTransition>
        </div>
      </div>
    </div>
  );
};

export default Main;
